// start:ng42.barrel
export * from './res-direct.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/res-direct/index.ts